import { WAREHOUSES_ACTIONS } from './warehouses.types'

/**
 * @param {Object.<string, import('./warehouses.types').Warehouse>} payload
 * @returns {Object}
 */
export const setWarehousesAction = payload => ({
  type: WAREHOUSES_ACTIONS.SET_WAREHOUSES,
  payload
})

/**
 * @param {import('./warehouses.types').Warehouse} payload
 * @returns {Object}
 */
export const setWarehouseAction = payload => ({
  type: WAREHOUSES_ACTIONS.SET_WAREHOUSE,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setWarehousesStatusAction = payload => ({
  type: WAREHOUSES_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setWarehousesErrorsAction = payload => ({
  type: WAREHOUSES_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearWarehousesErrorsAction = () => ({
  type: WAREHOUSES_ACTIONS.CLEAR_ERRORS
})
